import { render } from "./SideMenu.vue?vue&type=template&id=0cffd5fb&scoped=true"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"

import "./SideMenu.vue?vue&type=style&index=0&id=0cffd5fb&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cffd5fb"]])

export default __exports__